export const closeCategories = {
  country: [
    [
      'Austria',
      'Czech Republic',
      'Germany',
      'Hungary',
      'Liechtenstein',
      'Poland',
      'Slovakia',
      'Slovenia',
      'Switzerland',
      'Andorra',
      'Belgium',
      'Denmark',
      'Finland',
      'France',
      'Greece',
      'Iceland',
      'Ireland',
      'Italy',
      'Luxembourg',
      'Malta',
      'Monaco',
      'Netherlands',
      'Norway',
      'Portugal',
      'San Marino',
      'Spain',
      'Sweden',
      'Vatican City',
      'Albania',
      'Armenia',
      'Azerbaijan',
      'Belarus',
      'Bosnia and Herzegovina',
      'Bulgaria',
      'Croatia',
      'Cyprus',
      'Estonia',
      'Georgia',
      'Kosovo',
      'Latvia',
      'Lithuania',
      'Moldova',
      'Montenegro',
      'North Macedonia',
      'Romania',
      'Russia',
      'Serbia',
      'Turkey',
      'Ukraine',
    ],
  ],
  hairColour: [
    ['Black', 'Brown'],
    ['Blonde', 'Brown'],
  ],
  activity: [
    ['Very active', 'Active'],
    ['Active', 'Kinda active'],
    ['Kinda active', 'Inactive'],
  ],
};
